import styled from 'styled-components'
import Link from '../common3/Link'

export const Card = styled.div`
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 6px 10px rgba(0,0,0,.08), 0 0 6px rgba(0,0,0,.05);
    transition: .3s transform cubic-bezier(.155,1.105,.295,1.12),.3s box-shadow,.3s -webkit-transform cubic-bezier(.155,1.105,.295,1.12);
    cursor: ${p => !p.disabled ? 'pointer' : 'default'};

    border-left: ${p => p.selected ? '4px solid red' : 'none'};

    display:flex;
    justify-content:space-between;

    margin: 10px;

    min-height:100px;
    padding:15px;

    width: ${p => p.cardWidth};
    

    ${p => !p.disabled && `
    &:hover{
      transform: scale(1.01);
      box-shadow: 0 10px 20px rgba(0,0,0,.12), 0 4px 8px rgba(0,0,0,.06);
    }
    `}
    

`


export const CardLink = styled(Link)`
    width: ${p => p.cardWidth};
`


export const InfoBar = styled.div`
    margin-bottom:20px;
`

export const CardsWrapper = styled.div`
    display:flex;
    flex-wrap:wrap;
    padding:10px;
`